import { IState } from '../store';

export const selectisNewbuildingBrokerFlatBannerSubmitted = (state: IState): boolean =>
  state.isNewbuildingBrokerFlatBannerSubmitted;
